import { Color, Vector2 } from '../../odie';
import {
  Container,
  IPointData,
  Point,
  Rectangle,
  Ticker,
  InteractionEvent,
} from '../../odie';

import {
  BoundsType,
  DirectionType,
  PositionType,
  positionZero,
} from '../defs/types';

// vector
//-----------------------------------------------------------------------------
export function pixiPointToVector(
  point: PositionType | DirectionType,
): Vector2 {
  return new Vector2(point.x, point.y);
}

// get unit vector from radians angle
export function pixiVectorFromAngle(angle: number): Vector2 {
  return new Vector2(Math.cos(angle), Math.sin(angle));
}

// color
//-----------------------------------------------------------------------------
export function pixiColorFromHex(hex: number): Color {
  return new Color(0, 0, 0).setHex(hex);
}

// etc
//-----------------------------------------------------------------------------
export function pixiGetDt(): number {
  return Ticker.system.deltaMS / 1000;
}

// ui
//-----------------------------------------------------------------------------

export function pixiGetRelativePosition(
  from: Container,
  to: Container,
): PositionType {
  return to.toLocal(positionZero as Point, from);
}

export function pixiGetRelativeBounds(
  from: Container,
  to: Container,
): Rectangle {
  const bounds = from.getLocalBounds();

  // get relative  position
  const position = pixiGetRelativePosition(from, to);

  return new Rectangle(position.x, position.y, bounds.width, bounds.height);
}

export function pixiToLocalBounds(
  object: Container,
  bounds: BoundsType,
): Rectangle {
  const position = object.toLocal(bounds as IPointData);
  return new Rectangle(position.x, position.y, bounds.width, bounds.height);
}

// like setting scale, but preserves current sign
export function pixiSignScale(object: Container, x: number, y?: number) {
  const xSign = Math.sign(object.scaleX);
  const ySign = Math.sign(object.scaleY);
  y = y || x;

  object.scaleX = xSign * Math.abs(x);
  object.scaleY = ySign * Math.abs(y);
}

export function pixiSetEnabledFilter(object: Container, enabled: boolean) {
  // if enabled, remove filters
  if (enabled) {
    // object.filters = [];
    // else add grayscale filter
  } else {
    // const grayscale = new filters.ColorMatrixFilter();
    // grayscale.grayscale(0.4, false);
    // object.filters = [grayscale];
  }
}

export function pixiEmitTree(
  object: Container,
  eventName: string,
  eventObj: unknown,
) {
  console.warn(
    'Not yet implemented: pixiEmitTree',
    object,
    eventName,
    eventObj,
  );
}
